var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-item-group",
        [
          _c(
            "v-row",
            { attrs: { justify: "center", align: "center" } },
            _vm._l(_vm.memberships, function (membership, index) {
              return _c(
                "v-col",
                {
                  key: membership.id,
                  staticClass: "flex justify-center pa-0",
                  attrs: {
                    cols: "12",
                    sm: _vm.memberships.length == 2 ? 6 : 12,
                    md:
                      _vm.memberships.length == 1
                        ? 12
                        : _vm.memberships.length == 3
                        ? 4
                        : 6,
                  },
                },
                [
                  _c(
                    "v-item",
                    [
                      _c("FoundersClubCard", {
                        attrs: {
                          membership: membership,
                          title: membership.title,
                          subtitle: membership.subtitle,
                          heading: _vm.heading,
                          image: membership.image,
                          description: membership.description,
                          button1: _vm.button1,
                          button2: _vm.button2,
                          recommended: membership.id == _vm.recommendation,
                          width: _vm.memberships.length > 1 ? 350 : null,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$emit("input", $event)
                          },
                          learnMore: function ($event) {
                            return _vm.$emit("learnMore", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }